<template>
  <radio-buttons
    :options="options"
    :value="on"
    :active-color="onColor"
    :inactive-color="offColor"
    :disabled="disabled"
    @input="input"
  />
</template>

<script>
import RadioButtons from '~lib/common/components/RadioButtons';

export default {
  name: 'toggle',
  components: {
    RadioButtons,
  },
  props: {
    on: {
      type: Boolean,
      default: false,
    },
    onColor: {
      type: String,
      default: undefined
    },
    offColor: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [
        {
          value: true,
          label: 'ON',
        },
        {
          value: false,
          label: 'OFF',
        },
      ],
    };
  },
  methods: {
    input(value) {
      this.$emit(value ? 'on' : 'off');
      this.$emit('toggle', value);
    },
  },
};
</script>

<style scoped>
</style>
